module.exports = __webpack_public_path__ + "static/media/bg-img.aafb82a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bg-img.png
// module id = 1151
// module chunks = 0